import { useEffect, useRef, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";

const ProjectPopUp = (props) => {
  const popupref = useRef(null);
  const [search, setsearch] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref]);

  const handlemessageChange = (event) => {
    setsearch(event.target.value);
  };
  return (
    props.visible && (
      <div
        ref={popupref}
        className={`w-[250px] ${
          props.multi == true ? "max-h-[215px]" : "max-h-[1855px]"
        }  bg-themelightblack border border-white/20 rounded-md overflow-y-scroll gk-scr p-[10px] position absolute z-10  top-[50px] left-[0px]  self-start`}
        style={props.style}
      >
        {props.multi == true && (
          <div
            onClick={() => {
              props.selectedproject.length == props.data.length
                ? props.bulkaction(false)
                : props.bulkaction(true);
            }}
            className={`flex flex-row items-center justify-end  w-full py-[5px] cursor-pointer text-textcolor   hover:underline hover:text-white/80  hover:rounded-xl `}
          >
            <p className=" PoppinsRegular text-sm ml-[10px]">
              {props.selectedproject.length == props.data.length
                ? "Deselect All"
                : "Select All"}
            </p>
          </div>
        )}

        <input
          type="text"
          value={search}
          placeholder="Search"
          onChange={handlemessageChange}
          className="input px-4 text-black text-sm  PoppinsRegular w-full py-2 rounded-xl border border-white/20 items-center flex mb-[10px] bg-white"
        />
        <div className="w-full overflow-y-scroll max-h-[120px]">
          {props.type != "address"
            ? props.data.map((item, index) =>
                item.title.toLowerCase().includes(search.toLowerCase()) ? (
                  props.assignedProjects != undefined &&
                  props.assignedProjects.has(item?.id) ? (
                    <div
                      onClick={props.onClickincorrect}
                      className={`flex flex-row items-center  w-full py-[5px] cursor-pointer bg-gray  text-textcolor px-[10px] rounded-xl`}
                      style={{ backgroundColor: "gray", marginBottom: 2 }}
                    >
                      <img loading="lazy"
                        src={item.logo}
                        className="w-[25px] h-[25px] rounded-full object-cover"
                      />

                      <p className="  PoppinsRegular text-sm ml-[10px]">
                        {item.title}
                      </p>
                    </div>
                  ) : (
                    <div
                      onClick={() => {
                        props.onClickcorrect(item);
                      }}
                      className={`flex flex-row items-center  w-full py-[5px] cursor-pointer hover:bg-themeblue text-white  hover:px-[10px] hover:rounded-xl`}
                    >
                      <img loading="lazy"
                        src={item.logo}
                        className="w-[25px] h-[25px] rounded-full object-cover"
                      />

                      <p className="  PoppinsRegular text-sm ml-[10px]">
                        {item.title}
                      </p>
                      {props?.selectedproject?.find(
                        (data) => data.id == item.id,
                      ) != undefined && (
                        <IoCheckmarkCircle className="   w-[20px] h-[20px] text-themegreen" />
                      )}
                    </div>
                  )
                ) : null,
              )
            : props.data.map((item, index) =>
                item.destination
                  .toLowerCase()
                  .includes(search.toLowerCase()) ? (
                  <div
                    onClick={() => {
                      props.onClickcorrect(item);
                    }}
                    className={`flex flex-row items-center  w-full py-[5px] cursor-pointer hover:bg-themeblue text-white  hover:px-[10px] hover:rounded-xl`}
                  >
                    <p className="  PoppinsRegular text-sm ml-[10px]">
                      {item.destination}
                    </p>
                  </div>
                ) : null,
              )}
        </div>
      </div>
    )
  );
};

export default ProjectPopUp;
